export enum GameNames {
    INIT = 0,
    TALK = 1,
    QUESTION = 2,
    IMAGE = 3,
    IMAGE_PAR = 31,
    ANIMATION = 4,
    CONDITION = 6,
    INPUT = 7,
    CHARACTERS = 9,
    UI = 10,
    INSTA = 'INSTA',
    SET_INSTA = 121,
    JUMP = 13,
    PHONE = 'PHONE',
    PARAMS = 15,
    LAST_UPDATED = 16,
    SOUND = 17,
    END_REPLAY = 18,
}